var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaneKeepAssist32 = function SvgLaneKeepAssist32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.86 7h2.28c1.023 0 2.005.398 2.73 1.108A3.743 3.743 0 0 1 21 10.782v11.041c0 .843-.342 1.65-.95 2.247a3.277 3.277 0 0 1-2.293.93h-3.514c-.426 0-.848-.082-1.241-.242a3.249 3.249 0 0 1-1.052-.688 3.173 3.173 0 0 1-.703-1.031A3.12 3.12 0 0 1 11 21.823v-11.04c0-1.004.407-1.966 1.13-2.675A3.902 3.902 0 0 1 14.86 7v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.708 12h2.557c.99 0 1.94.391 2.641 1.088A3.703 3.703 0 0 1 21 15.713v4.274c0 .269-.107.526-.298.716-.191.19-.45.297-.72.297h-7.963c-.27 0-.53-.107-.72-.297a1.01 1.01 0 0 1-.299-.716V15.7a3.703 3.703 0 0 1 1.09-2.608A3.746 3.746 0 0 1 14.707 12v0ZM11 15H9m14 0h-2M3 2v28M29 2v28",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLaneKeepAssist32;